// Renders a static preview of a design's elements, scaled to fit a container width.
export default function CanvasPreview({ design, targetWidth = 260 }) {
  const w = design?.width || 1080;
  const h = design?.height || 1350;
  const scale = targetWidth / w;
  const elements = design?.elements || [];

  return (
    <div style={{ width: targetWidth, height: h * scale, position: "relative", overflow: "hidden" }}>
      <div style={{ width: w, height: h, background: design?.background || "#ffffff", transform: `scale(${scale})`, transformOrigin: "top left", position: "absolute", top: 0, left: 0 }}>
        {elements.map((el) => {
          const base = { position: "absolute", left: el.x, top: el.y, width: el.width, height: el.height, opacity: el.opacity ?? 1, transform: el.rotation ? `rotate(${el.rotation}deg)` : undefined };
          if (el.type === "text")
            return (
              <div key={el.id} style={{ ...base, fontSize: el.fontSize, fontWeight: el.fontWeight, fontStyle: el.fontStyle, color: el.color, textAlign: el.textAlign, fontFamily: el.fontFamily, letterSpacing: el.letterSpacing, lineHeight: el.lineHeight || 1.15, whiteSpace: "pre-wrap", overflow: "visible", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                {el.text}
              </div>
            );
          if (el.type === "image")
            return <img key={el.id} src={el.src} alt="" style={{ ...base, objectFit: el.objectFit || "cover", borderRadius: el.borderRadius || 0 }} />;
          if (el.type === "ellipse")
            return <div key={el.id} style={{ ...base, background: el.fill, borderRadius: "50%", border: el.borderWidth ? `${el.borderWidth}px solid ${el.borderColor}` : undefined }} />;
          return <div key={el.id} style={{ ...base, background: el.fill, borderRadius: el.borderRadius || 0, border: el.borderWidth ? `${el.borderWidth}px solid ${el.borderColor}` : undefined }} />;
        })}
      </div>
    </div>
  );
}
